import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17e1379d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-edit-investigation-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = {
  key: 0,
  class: "line1"
}
const _hoisted_4 = {
  key: 1,
  class: "line1"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line2" }, "Investigation types", -1))
const _hoisted_6 = {
  key: 0,
  class: "body-main has-indicator"
}
const _hoisted_7 = {
  key: 1,
  class: "body-main has-indicator"
}
const _hoisted_8 = {
  key: 2,
  class: "modal-body"
}
const _hoisted_9 = { class: "ls-form" }
const _hoisted_10 = { class: "body-line-1" }
const _hoisted_11 = { class: "input-box-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name of investigation type *", -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_16 = { class: "input-box-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Expected duration (in days) *", -1))
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_21 = { class: "body-line-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Investigation category", -1))
const _hoisted_23 = { class: "input-box" }
const _hoisted_24 = { class: "select mb-4" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: "0"
}, "- Please select -", -1))
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "radio-buttons" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Status", -1))
const _hoisted_29 = { style: {"display":"flex"} }
const _hoisted_30 = { style: {"float":"left"} }
const _hoisted_31 = { class: "radio" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Active")
], -1))
const _hoisted_33 = {
  class: "ml-4",
  style: {"float":"left"}
}
const _hoisted_34 = { class: "radio" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Inactive")
], -1))
const _hoisted_36 = { class: "row mt-4 ml-1" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      show: _ctx.show,
      "onUpdate:show": _cache[13] || (_cache[13] = $event => ((_ctx.show) = $event)),
      onClose: _cache[14] || (_cache[14] = $event => (_ctx.cancelClicked())),
      mostScreen: true
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isEdit)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Edit " + _toDisplayString(_ctx.formData.name), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, "Add new investigation type")),
          _hoisted_5
        ])
      ]),
      body: _withCtx(() => [
        (_ctx.isLoadingData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_LoadingIndicator)
            ]))
          : (_ctx.errorLoadingData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_ErrorIndicator)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("form", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("fieldset", _hoisted_11, [
                      _hoisted_12,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.formData.name) = $event)),
                        disabled: _ctx.isLoadingData,
                        onInput: _cache[1] || (_cache[1] = $event => (_ctx.mandatoryCheck())),
                        maxlength: "200"
                      }, null, 40, _hoisted_13), [
                        [_vModelText, _ctx.formData.name]
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["footnote", [ _ctx.formData.name.length === 200 ? 'full' : '']])
                      }, _toDisplayString(_ctx.formData.name.length) + "/200 characters ", 3),
                      (_ctx.formData.name === '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _hoisted_15,
                            _createTextVNode(" Mandatory field ")
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("fieldset", _hoisted_16, [
                      _hoisted_17,
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.formData.expectedDuration) = $event)),
                        disabled: _ctx.isLoadingData,
                        maxlength: "199",
                        onInput: _cache[3] || (_cache[3] = $event => (_ctx.mandatoryCheck()))
                      }, null, 40, _hoisted_18), [
                        [_vModelText, _ctx.formData.expectedDuration]
                      ]),
                      (_ctx.formData.expectedDuration < 0.25)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _hoisted_20,
                            _createTextVNode(" Number must be 0.25 or more ")
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("fieldset", null, [
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.formData.defaultInvestigationCategory.id) = $event)),
                            onChange: _cache[5] || (_cache[5] = $event => (_ctx.mandatoryCheck()))
                          }, [
                            _hoisted_25,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investigationCategory, (iC) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: iC.id
                              }, _toDisplayString(iC.name), 9, _hoisted_26))
                            }), 256))
                          ], 544), [
                            [_vModelSelect, _ctx.formData.defaultInvestigationCategory.id]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("fieldset", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("label", _hoisted_31, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.formData.status.id) = $event)),
                            name: "active",
                            value: 1,
                            onChange: _cache[7] || (_cache[7] = $event => (_ctx.mandatoryCheck()))
                          }, null, 544), [
                            [_vModelRadio, _ctx.formData.status.id]
                          ]),
                          _hoisted_32
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("label", _hoisted_34, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.formData.status.id) = $event)),
                            name: "active",
                            value: 2,
                            onChange: _cache[9] || (_cache[9] = $event => (_ctx.mandatoryCheck()))
                          }, null, 544), [
                            [_vModelRadio, _ctx.formData.status.id]
                          ]),
                          _hoisted_35
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[10] || (_cache[10] = $event => (_ctx.cancelClicked())),
                    disabled: _ctx.isLoadingData
                  }, " Back ", 8, _hoisted_37),
                  (_ctx.isEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-primary ml-2",
                        disabled: !_ctx.canSubmit || _ctx.isLoadingData,
                        onClick: _cache[11] || (_cache[11] = $event => (_ctx.submit()))
                      }, " Save changes ", 8, _hoisted_38))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-primary ml-2",
                        disabled: !_ctx.canSubmit || _ctx.isLoadingData,
                        onClick: _cache[12] || (_cache[12] = $event => (_ctx.submit()))
                      }, " Add ", 8, _hoisted_39)),
                  (_ctx.submitting)
                    ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                        key: 2,
                        class: "loading-indicator",
                        showLoadingText: false
                      }))
                    : _createCommentVNode("", true)
                ])
              ]))
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}